// Vendors
import { RELOADED_ANIMATIONS } from '@openbank/ziniaweb-ui-components';

const LOADING_COMPONENT_LOADER_PROPS = {
    altText: 'loading',
    animation: RELOADED_ANIMATIONS.PRIMARY,
    height: '56px',
    width: '56px',
    visible: true,
  },
  LOADING_COMPONENT_TITLE_PROPS = {
    showBuilder: false,
  };

export { LOADING_COMPONENT_LOADER_PROPS, LOADING_COMPONENT_TITLE_PROPS };
